var chunkToChildrenMap = {
	"188": [
		121
	],
	"321": [
		859
	],
	"325": [
		530,
		862
	],
	"348": [
		179,
		530
	],
	"424": [
		71
	],
	"481": [
		530
	],
	"624": [
		530
	],
	"669": [
		530
	],
	"907": [
		297
	],
	"961": [
		939
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));